<template>
 <div :class="windowClass">
        <v-row no-gutters>
            <v-col md="8"
            offset-md="2"
            class="pa-1 mt-10">
                   <v-text-field
                    filled
                    outlined
                    label="Banyera #."
                    v-model="container"
                    @change="getSale()"
                    @click:append-outer="getSale()"
                    append-outer-icon="mdi-send"
                   />
                <p class="title"><v-icon left color="error">mdi-view-sequential</v-icon> Series: {{sales.sequence}}</p>
                <p class="title"><v-icon left color="secondary">mdi-truck</v-icon> Fishcar: {{order.fishcar}}</p>
                <p class="title"><v-icon left color="success">mdi-account</v-icon> Customer: {{order.customer_name}}</p>
            </v-col>
        </v-row>
        <va-weigher-form :show="form" :fish="sales.name" @DialogEvent="formEvent" />
  </div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
    mixins: [API_MIXINS],
    data: () => ({
        form: false,
        loading: false,
        sales: {},
        order:{},
        container:'',
        fishcar:'',
        sequence: '',
        customer:'',
        settings:[]
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.selected_date = this.$moment().format('YYYY-MM-DD')
            this.loadSetting()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      SALES_AMOUNT(){
          var amount = this.$IsNum(this.sales.kilos) * this.$IsNum(this.sales.price)
          return amount + this.$IsNum(this.sales.trucking_fee) + this.$IsNum(this.sales.service_charge) 
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      formEvent(data){
        this.form = false
        if(data.action != 'close') {
            this.sales.kilos = data.weight
            this.sales.status = 'for payment'
            this.sales.trucking_fee = this.getSettingVal('trucking_fee')// this.$IsNum(data.weight) < 10 ?'0':this.getSettingVal('trucking_fee')
            console.log(this.sales.trucking_fee)
            if(this.order.evat) {
                this.sales.service_charge = (this.$IsNum(data.weight) * this.$IsNum(this.getSettingVal('service_charge'))).toString()
            } else {
                this.sales.service_charge = '0'
            }
            this.sales.amount = this.SALES_AMOUNT.toString()
           this.Save()
        }   
      },
      Reset(){
          this.sales ={}
             this.order = {}
             this.container = ''
      },
        Save(){
            this.$http.post("sale/update", this.sales).then(response => {
            if(response.data.status == true) {
                this.VA_ALERT('success', response.data.message)
            } else {
                this.VA_ALERT('error', response.data.message)
            }
             this.Reset()
            }).catch(e => {
            console.log(e.data)
            })
        },
      getSale(){
        this.$http.post("sale/query_by_id", JSON.stringify({container: this.container})).then(response => {
            if(response.data.data != null) {
              this.sales = response.data.data.sales
            } else { 
              this.sales = {} 
               this.VA_ALERT('error', 'No transaction found!')
            }
            response.data.order != null?this.order = response.data.order: this.order = {}
            if(this.sales.name && this.sales.status != 'paid') {
                this.form = true
            }
            }).catch(e => {
          console.log(e.data)
        })
      },
      loadSetting() {
          this.$http.post("setting/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.settings = response.data.data:this.settings = []
          }).catch(e => {
           console.log(e.data)
         })
      },
      getSettingVal(name) {
          for(var i =0;i<this.settings.length;i++) {
              if(this.settings[i].name == name) {
                  return this.settings[i].value
              }
          }
          return false
      }
    }
  }
</script>